const prod = {
  API_URL: "https://api-zebra.zndznd.com/api/v1",
  SOCKET_URL: "https://realtime-zebra.zndznd.com/",
  IMAGE_URL: "https://f003.backblazeb2.com/file/zebra-prod/",
  VIDEO_URL: "https://f003.backblazeb2.com/file/zebra-prod",
  MAM_INDEX: "zebra",
  SEARCH_INDEX: "mam",
  SEARCH_BCM_INDEX: "bcm",
  SEARCH_ENDPOINT: "https://search-zebra.zndznd.com/api/SearchElastic/",
  ENTRA_APPLICATION_ID: "16b5cefb-e640-4c21-aaa1-6a093c8cad52",
  ENTRA_TENANT_ID: "3b456120-88a4-4f0f-88ac-551dda8ca10f",
  MEEMOO_RECORD_SEARCH_URL:
    "https://zebra-p-func-001-meemoo-status.azurewebsites.net/api/meemoo_record_search?code=JInNANQzpC9tA0NGVyDcOcIRenuPOCoTRlTFVsAManNAAzFuLA3-bQ%3D%3D",
  AZURE_STORAGE_CONNECTION_STRING:
    "BlobEndpoint=https://zebrapstor001upload.blob.core.windows.net/;QueueEndpoint=https://zebrapstor001upload.queue.core.windows.net/;FileEndpoint=https://zebrapstor001upload.file.core.windows.net/;TableEndpoint=https://zebrapstor001upload.table.core.windows.net/;SharedAccessSignature=",
  AZURE_STORAGE_CONTAINER_NAME: "zebra-p-cont-001-upload",
  AZURE_GET_UPLOAD_SAS_TOKEN_URL:
    "https://zebra-p-func-001-upload-cueag4bbd6c2eucf.westeurope-01.azurewebsites.net/api/GenerateUploadSasToken",
  EXPORTER_DOMAIN: "https://deburen-p-wapp-001-exporter.azurewebsites.net/"
};

const preview = {
  API_URL: "https://test-api-zebra.zndznd.com/api/v1",
  SOCKET_URL: "https://realtime-zebra.zndznd.com/",
  IMAGE_URL: "https://f003.backblazeb2.com/file/zebra-prod/",
  VIDEO_URL: "https://f003.backblazeb2.com/file/zebra-prod",
  MAM_INDEX: "zebra",
  SEARCH_INDEX: "mam",
  SEARCH_BCM_INDEX: "bcm",
  SEARCH_ENDPOINT: "https://search-zebra.zndznd.com/api/SearchElastic/",
  ENTRA_APPLICATION_ID: "16b5cefb-e640-4c21-aaa1-6a093c8cad52",
  ENTRA_TENANT_ID: "3b456120-88a4-4f0f-88ac-551dda8ca10f",
  MEEMOO_RECORD_SEARCH_URL:
    "https://zebra-p-func-001-meemoo-status.azurewebsites.net/api/meemoo_record_search?code=JInNANQzpC9tA0NGVyDcOcIRenuPOCoTRlTFVsAManNAAzFuLA3-bQ%3D%3D",
  AZURE_STORAGE_CONNECTION_STRING:
    "BlobEndpoint=https://zebrapstor001upload.blob.core.windows.net/;QueueEndpoint=https://zebrapstor001upload.queue.core.windows.net/;FileEndpoint=https://zebrapstor001upload.file.core.windows.net/;TableEndpoint=https://zebrapstor001upload.table.core.windows.net/;SharedAccessSignature=",
  AZURE_STORAGE_CONTAINER_NAME: "zebra-p-cont-001-upload",
  AZURE_GET_UPLOAD_SAS_TOKEN_URL:
    "https://zebra-p-func-001-upload-cueag4bbd6c2eucf.westeurope-01.azurewebsites.net/api/GenerateUploadSasToken",
  EXPORTER_DOMAIN: "https://deburen-p-wapp-001-exporter.azurewebsites.net/"
};

const dev_local = {
  API_URL: "http://localhost:52134/api/v1",
  SOCKET_URL: "https://realtime-zebra.zndznd.com/",
  IMAGE_URL: "https://f003.backblazeb2.com/file/zebra-prod/",
  VIDEO_URL: "https://f003.backblazeb2.com/file/zebra-prod",
  MAM_INDEX: "zebra",
  SEARCH_INDEX: "mam",
  ENTRA_APPLICATION_ID: "16b5cefb-e640-4c21-aaa1-6a093c8cad52",
  ENTRA_TENANT_ID: "3b456120-88a4-4f0f-88ac-551dda8ca10f",
  MEEMOO_RECORD_SEARCH_URL: "https://zebra-p-func-001-meemoo-status.azurewebsites.net/api/meemoo_record_search?code=JInNANQzpC9tA0NGVyDcOcIRenuPOCoTRlTFVsAManNAAzFuLA3-bQ%3D%3D",
  EXPORTER_DOMAIN: "https://deburen-p-wapp-001-exporter.azurewebsites.net/"
};

const dev = {
  API_URL: "http://localhost:52134/api/v1",
  SOCKET_URL: "https://realtime-zebra.zndznd.com/",
  IMAGE_URL: "https://f003.backblazeb2.com/file/zebra-prod",
  MAM_INDEX: "zebra_test",
  SEARCH_INDEX: "mam",
  ENTRA_APPLICATION_ID: "16b5cefb-e640-4c21-aaa1-6a093c8cad52",
  ENTRA_TENANT_ID: "3b456120-88a4-4f0f-88ac-551dda8ca10f",
  MEEMOO_RECORD_SEARCH_URL: "https://zebra-p-func-001-meemoo-status.azurewebsites.net/api/meemoo_record_search?code=JInNANQzpC9tA0NGVyDcOcIRenuPOCoTRlTFVsAManNAAzFuLA3-bQ%3D%3D",
  EXPORTER_DOMAIN: "https://deburen-p-wapp-001-exporter.azurewebsites.net/"
};

const local = { ...dev };
//local.API_URL = "http://localhost:52134/api/v1";
local.API_URL = "http://zebra-api.local/api/v1";

// Get mode from Vite (browser/build) or Node.js (Jest tests)
// In Jest: use process.env
// In Vite: import.meta.env.MODE gets statically replaced at build time
const mode = typeof process !== 'undefined' && process.env && (process.env.MODE || process.env.NODE_ENV)
  ? (process.env.MODE || process.env.NODE_ENV)
  : import.meta.env.MODE || 'production';

export const config =
    mode === "development"
        ? dev
        : mode === "preview"
            ? preview
            : mode === "dev_local"
                ? dev_local
                : prod;
